import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]
  
  connect() {
    console.log("Team invitations controller connected")
    this.index = 1
  }
  
  add(event) {
    event.preventDefault()
    console.log("Add button clicked, current index:", this.index)
    
    const clone = this.templateTarget.cloneNode(true)
    
    // Update field names with unique index
    clone.querySelectorAll('input, select').forEach(input => {
      const name = input.getAttribute('name')
      if (name) {
        const newName = name.replace(/\[\d+\]/, `[${this.index}]`)
        input.setAttribute('name', newName)
        input.value = ''
      }
    })
    
    // Add remove button at the end of the cloned field
    const removeBtn = document.createElement('button')
    removeBtn.type = 'button'
    removeBtn.className = 'text-theme-error hover:text-theme-error/80 text-sm px-2 py-1 rounded hover:bg-theme-error/10 mt-2'
    removeBtn.textContent = '✕ Remove'
    removeBtn.dataset.action = 'click->team-invitations#remove'
    clone.appendChild(removeBtn)
    
    clone.classList.add('mt-4')
    this.containerTarget.appendChild(clone)
    this.index++
    
    console.log("Field added, new index:", this.index)
  }
  
  remove(event) {
    event.preventDefault()
    const field = event.target.closest('[data-team-invitations-target="template"]')
    const allFields = this.containerTarget.querySelectorAll('[data-team-invitations-target="template"]')
    
    if (allFields.length > 1 && field) {
      field.remove()
    }
  }
}

